module.exports = __webpack_public_path__ + "img/07.f7bfe4b4.jpg";